"use strict";
//import Button from "./Button";
import Application from "./Application";

function Common() {
}
export default Common;

//====================================//
//=====PROJECT SPECIFIC VARIABLES=====//
//====================================//

/**
 * Wrapper for legacy of jons old happo paint game
 * @type {{assetRes: number}}
 */
Common.main = {assetRes: 1};

/**
 * Currently selected intellectual property
 * @type {string}
 */
Common.themeIndex = 0;

/**
 * @type {signals.Signal}
 */
Common.killGlowSignal = new signals.Signal();

/**
 * @type {signals.Signal}
 */
Common.toggleCurrentGlowSignal = new signals.Signal();

/**
 * @param arr
 */
Common.buttonsAppear = function (arr) {
    for (let i = 0; i < arr.length; i++) {
        arr[i].scale.set(0);
        TweenMax.to(arr[i].scale, 0.34, {
            x: 1,
            y: 1,
            ease: Back.easeOut,
            easeParams: [2],
            delay: i * 0.15 + 0.25
        });
    }
};

//====================================//
//========PROJECT SPECIFIC END========//
//====================================//

/**
 * @type {null|P3.AssetManager}
 */
Common.assets = null;

/**
 * @type {P3.View}
 */
Common.view = null;

/**
 * @type {number}
 */
Common.paused = false;

/**
 * @type {boolean}
 */
Common.isWebGL = false;

/**
 * @type {boolean}
 */
Common.isFirstPlay = true;

/**
 * @type {boolean}
 */
Common.isDebug = false;

/**
 * @type {boolean}
 */
Common.isMute = false;

//===============//
//==static vars==//
//===============//

/**
 * Semi unique key used as an identifier for save files, followed by the version
 * (useful if you want players to start a new game, increment version number)
 * @static
 * @type {string}
 */
Common.game_key = "rozhc7o7-dsn-create-v1.0";

/**
 * @static
 * @type {AudioManager}
 */
Common.audio = null;

/**
 * @static
 * @type {P3.Camera}
 */
Common.camera = null;

/**
 * @static
 * @type {number}
 * @const
 */
Common.PHYSICS_TICK = 1.0 / 30.0;

/**
 * @static
 * @type {object}
 */
Common.copy = null;

/**
 * @static
 * @type {object}
 */
Common.config = null;

/**
 * @type {string}
 * @static
 */
Common.language = "";

/**
 * @static
 * @const
 * @type {number}
 */
Common.STAGE_WIDTH = 1664;

/**
 * @static
 * @const
 * @type {number}
 */
Common.STAGE_HEIGHT = 768;

/**
 * @static
 * @type {PIXI.Container}
 */
Common.stage = null;

/**
 * @static
 * @type {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
 */
Common.renderer = null;

//===============//
//==static ends==//
//===============//

//================================//
//=====save and load functions====//
//================================//

Common.saveMute = function () {
    const data = {isMute: Common.isMute};
    localStorage.setItem(Common.game_key + "_isMute", JSON.stringify(data));
};

Common.loadMute = function () {
    const data = JSON.parse(localStorage.getItem(Common.game_key + "_isMute"));
    if (data) {
        Common.isMute = data.isMute;
        Common.audio.mute(Common.isMute);
    }
};

Common.saveGame = function () {
    const gameData = {highestScore: Common.highestScore};
    localStorage.setItem(Common.game_key, JSON.stringify(gameData));
};

Common.loadGame = function () {
    const gameData = JSON.parse(localStorage.getItem(Common.game_key));
    if (gameData) {
        Common.highestScore = gameData.highestScore;
        Common.isFirstPlay = false;
    } else {
        Common.isFirstPlay = true;
    }
};

//=========================================================//
//=============Rest is all util type functions=============//
//=========================================================//

/**
 * Knuth shuffle variant
 * @param string
 * @returns {string}
 */
Common.shuffleString = function (string) {
    const a = string.split(""); //our array
    const n = a.length; //number of elements
    for (var i = n - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let tmp = a[i];
        a[i] = a[j];
        a[j] = tmp;
    }
    return a.join("");
};

/**
 * Knuth shuffle
 * @param a
 * @returns {*}
 */
Common.shuffleArr = function (a) {
    for (let i = a.length; i; i--) {
        let j = Math.floor(Math.random() * i);
        [a[i - 1], a[j]] = [a[j], a[i - 1]];
    }
    return a;
};

/**
 * Generates a random string for use as a semi unique ID for save data
 * @param strLen - Desired length of random string
 * @returns {string}
 */
Common.randomID = function (strLen) {
    strLen = strLen || 8;
    return Math.random().toString(36).substr(2, strLen);
};

/**
 * Returns the angle between two points, where 0 is 3 o clock, 90 degrees is 6 o clock, etc.
 * @param x1 {number}
 * @param y1 {number}
 * @param x2 {number}
 * @param y2 {number}
 * @returns {number}
 */
Common.angle = function (x1, y1, x2, y2) {
    var dy = y2 - y1;
    var dx = x2 - x1;
    return Math.atan2(dy, dx);
};

/**
 * @param {number} x1 - Coordinate X of 1st point
 * @param {number} y1 - Coordinate Y of 1st point
 * @param {number} x2 - Coordinate X of 2nd point
 * @param {number} y2 - Coordinate Y of 2nd point
 * @returns {number} distance - Euclidean distance between the two points
 */
Common.distance = function (x1, y1, x2, y2) {
    return Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
};

/**
 * @param {number} deg
 * @returns {number} rad
 */
Common.deg2rad = function (deg) {
    return deg * (Math.PI / 180);
};

/**
 * @param rad
 * @returns {number}
 */
Common.rad2deg = function (rad) {
    return rad * 180 / Math.PI; // rads to degs, range (-180, 180]
};

/**
 * Returns a new keyboard object that listens for keyboard input
 * @param keyCode
 * @returns {{}}
 */
Common.keyboard = function (keyCode) {
    var key = {};
    key.code = keyCode;
    key.isDown = false;
    key.isUp = true;
    key.down = undefined;
    key.up = undefined;
    //The `downHandler`
    key.downHandler = function (event) {
        if (event.keyCode === key.code) {
            if (key.isUp && key.down) key.down();
            key.isDown = true;
            key.isUp = false;
        }
        event.preventDefault();
    };

    //The `upHandler`
    key.upHandler = function (event) {
        if (event.keyCode === key.code) {
            if (key.isDown && key.up) key.up();
            key.isDown = false;
            key.isUp = true;
        }
        event.preventDefault();
    };

    //Attach event listeners
    window.addEventListener(
        "keydown", key.downHandler.bind(key), false
    );
    window.addEventListener(
        "keyup", key.upHandler.bind(key), false
    );
    return key;
};

/**
 * @param width
 * @param height
 * @param colour
 * @param shape
 * @returns {Texture}
 */
Common.genTex = function (width, height, colour, shape) {
    let g = new PIXI.Graphics();
    if (colour) g.beginFill(colour);
    else g.beginFill(0x000fff);
    if (shape === "rect") g.drawRect(0, 0, width, height);
    else if (shape === "circle") g.drawEllipse(0, 0, width, height);
    else g.drawRect(0, 0, width, height);//fallback to rect
    g.endFill();
    return Common.renderer.generateTexture(g);
};

/**
 * Returns a new sprite that uses a texture generated using pixi graphics, mostly for debug and prototyping etc.
 * @param width
 * @param height
 * @param colour
 * @param retTexture - should we return a texture or a sprite?
 * @returns {PIXI.Sprite|String}
 */
Common.generateRect = function (width, height, colour, retTexture) {
    let g = new PIXI.Graphics();
    if (colour) g.beginFill(colour);
    else g.beginFill(0x000fff);
    g.lineStyle(5, 0xd9d9d9);
    g.drawRect(0, 0, width, height);
    g.endFill();
    let texture = Common.renderer.generateTexture(g);
    let sprite = new PIXI.Sprite(texture);
    sprite.anchor = {x: 0.5, y: 0.5};
    g.destroy();
    if (!retTexture) return sprite;
    sprite.destroy();
    return texture;
};

/**
 * Returns a new sprite that uses a texture generated using pixi graphics, mostly for debug and prototyping etc.
 * @param width
 * @param height
 * @param colour
 * @param retTexture - Should we return a texture or a sprite?
 * @returns {PIXI.Sprite|PIXI.Texture}
 */
Common.generateEllipse = function (width, height, colour, retTexture) {
    let g = new PIXI.Graphics();
    if (colour) g.beginFill(colour);
    else g.beginFill(0xfff000);
    g.drawEllipse(0, 0, width, height);
    g.endFill();
    let texture = Common.renderer.generateTexture(g);
    let sprite = new PIXI.Sprite(texture);
    sprite.anchor.set(0.5);
    g.destroy();
    if (!retTexture) return sprite;
    else return texture;
};

/**
 * Centres all sprites passed to it
 * @param sprite
 */
Common.centreAnchor = function (sprite) {
    for (let i = 0; i < arguments.length; i++) arguments[i].anchor.set(0.5);
};

/**
 * Returns a matrix of defined size with optional initial values
 * @param {number} numRows - Number rows in matrix
 * @param {number} numCols - Number of columns in matrix
 * @param initial - Optional initial value
 * @returns {Array}
 */
Common.matrix = function (numRows, numCols, initial) {
    const arr = [];
    for (let i = 0; i < numRows; i++) {
        const columns = [];
        for (let j = 0; j < numCols; j++) columns[j] = initial;
        arr[i] = columns;
    }
    return arr;
};

/**
 * Returns array of defined size with optional initial values
 * @param {number} size
 * @param initial
 * @returns {Array}
 */
Common.array = function (size, initial) {
    const arr = [];
    for (let i = 0; i < size; i++) arr.push(initial);
    return arr;
};

/**
 * Uses quick sort to sort an array, with optional flag to sort high to low
 * @param array
 * @param highToLow
 * @returns {*}
 */
Common.sort = function (array, highToLow) {
    const size = array.length - 1;
    quickSort(0, size);
    return array;

    function quickSort(first, last) {

        if (first < last) {
            const pivotIndex = partition();
            quickSort(first, pivotIndex - 1);
            quickSort(pivotIndex + 1, last);
        }

        function swap(p, q) {
            const temp = array[p];
            array[p] = array[q];
            array[q] = temp;
        }

        function partition() {
            let pivot = array[first], index = first;
            swap(index, last);
            for (let i = first; i < last; i++) {
                if (!highToLow && array[i] < pivot) swap(index++, i);
                else if (highToLow && array[i] > pivot)swap(index++, i);
            }
            swap(index, last);
            return index;
        }
    }
};

/**
 * Sorts tiles (or any display object) by x, y coordinates so they are ordered lowest top to bottom , left to right
 * @param array
 * @returns {*}
 */
Common.sortTiles = function (array) {
    array.sort(function (a, b) {
        if (a.y == b.y) return a.x - b.x;
        else return a.y - b.y;
    });
    return array;
};

/**
 * Sorts object with an x or y property (such as sprites) by x or y dependant on flag
 * @param array - array to sort
 * @param highToLow - sort high to low?
 * @param sortX - flag to choose whether to sort by x or y
 * @returns {*}
 */
Common.sortBy = (array, highToLow, sortX) => {

    const size = array.length - 1;
    quickSort(0, size);
    return array;

    function quickSort(first, last) {
        if (first < last) {
            const pivotIndex = partition();
            quickSort(first, pivotIndex - 1);
            quickSort(pivotIndex + 1, last);
        }
        function swap(p, q) {
            const temp = array[p];
            array[p] = array[q];
            array[q] = temp;
        }

        function partition() {
            let pivot = array[first], index = first;
            swap(index, last);
            for (let i = first; i < last; i++) {
                if (!highToLow) {
                    if (x) {
                        if (array[i].x < pivot.x) swap(index++, i);
                    } else {
                        if (array[i].y < pivot.y) swap(index++, i);
                    }
                }
                else {
                    if (x) {
                        if (array[i].x > pivot.x) swap(index++, i);
                    } else {
                        if (array[i].y > pivot.y) swap(index++, i);
                    }
                }
            }
            swap(index, last);
            return index;
        }
    }
};

/**
 * Sorts object with a distance property
 * @param array - array to sort
 * @param highToLow - sort high to low?
 * @returns {*}
 */
Common.sortDistances = (array, highToLow) => {

    highToLow = highToLow || false;

    const size = array.length - 1;
    quickSort(0, size);
    return array;

    function quickSort(first, last) {
        if (first < last) {
            const pivotIndex = partition();
            quickSort(first, pivotIndex - 1);
            quickSort(pivotIndex + 1, last);
        }
        function swap(p, q) {
            const temp = array[p];
            array[p] = array[q];
            array[q] = temp;
        }

        function partition() {
            let pivot = array[first], index = first;
            swap(index, last);
            for (let i = first; i < last; i++) {
                if (!highToLow) {
                    if (array[i].distance < pivot.x) swap(index++, i);
                }
                else {
                    if (array[i].distance > pivot.distance) swap(index++, i);
                }
            }
            swap(index, last);
            return index;
        }
    }
};

Common.compareXY = function (point1, point2) {
    return (Math.round(point1.x) === Math.round(point2.x) && Math.round(point1.y) === Math.round(point2.y));
};

Common.lerpAxis = function (start, end, percent) {
    return ((end - start) * percent) + start;
};

Common.lerpVector = function (start, end, percent) {
    return Common.Vector.add((Common.Vector.scale((Common.Vector.sub(start, end)), percent)), start);
};

Common.Vector = {
    add: (a, b)=> {
        if (a.x === undefined || b.x === undefined) throw new Error('Vector.add() must be passed a pair of vectors');
        return {x: a.x + b.x, y: a.y + b.y};
    },
    sub: (a, b)=> {
        if (a.x === undefined || b.x === undefined) throw new Error('Vector.sub() must be passed a pair of vectors');
        return {x: a.x - b.x, y: a.y - b.y};
    },
    mult: (a, b)=> {
        if (a.x === undefined || b.x === undefined) throw new Error('Vector.mult() must be passed a pair of vectors');
        return {x: a.x * b.x, y: a.y * b.y};
    },
    div: (a, b)=> {
        if (a.x === undefined || b.x === undefined) throw new Error('Vector.div() must be passed a pair of vectors');
        return {x: a.x / b.x, y: a.y / b.y};
    },
    scale: (a, scalePerc)=> {
        if (a.x === undefined) throw new Error('Vector.scale() must be passed a vector for first arg');
        return {x: a.x * scalePerc, y: a.y * scalePerc};
    }
};

Common.lookAt = function (sprite, target, update) {
    const rotation = (Math.atan2(target.y - sprite.y, target.x - sprite.x));
    if (update) sprite.rotation = rotation;
    return rotation;
};

//--from stackoverflow-- https://stackoverflow.com/questions/14962018/detecting-and-fixing-circular-references-in-javascript //
Common.detectCircularRef = function (obj) {

    return detectCircularReferences(obj);

    function detectCircularReferences(toBeStringifiedValue, serializationKeyStack = []) {
        Object.keys(toBeStringifiedValue).forEach(key => {
            var value = toBeStringifiedValue[key];
            var serializationKeyStackWithNewKey = serializationKeyStack.slice();
            serializationKeyStackWithNewKey.push(key);
            try {
                JSON.stringify(value);
            }
            catch (error) {
                var isCircularValue;
                var circularExcludingStringifyResult = "";
                try {
                    circularExcludingStringifyResult = JSON.stringify(value, replaceRootStringifyReplacer(value), 2);
                    isCircularValue = true;
                }
                catch (error) {
                    detectCircularReferences(value, serializationKeyStackWithNewKey);
                    isCircularValue = false;
                }
                if (isCircularValue) {
                    throw new Error(`Circular reference detected:\nCircularly referenced value is value under path "${joinStrings(serializationKeyStackWithNewKey)}" of the given root object\n` +
                        `Calling stringify on this value but replacing itself with [Circular object --- fix me] ( <-- search for this string) results in:\n${circularExcludingStringifyResult}\n`);
                }
            }
        });
    }

    function replaceRootStringifyReplacer(toBeStringifiedValue) {
        var serializedObjectCounter = 0;
        return function (key, value) {
            if (serializedObjectCounter !== 0 && typeof (toBeStringifiedValue) === 'object' && toBeStringifiedValue === value) {
                return '[Circular object --- fix me]';
            }
            serializedObjectCounter++;
            return value;
        };
    }

    function joinStrings(arr, separator = ":") {
        if (arr.length === 0)
            return "";
        return arr.reduce((v1, v2) => `${v1}${separator}${v2}`);
    }
};

//from github pixi-simple-gestures
Common.pinchable = function (sprite, inertia) {

    sprite.interactive = true;
    sprite.on('touchstart', start);
    sprite.on('touchend', end);
    sprite.on('touchendoutside', end);

    function start(e) {
        sprite.on('touchmove', move)
    }

    function move(e) {
        let t = e.data.originalEvent.targetTouches;
        if (!t || t.length < 2) {
            return
        }
        let dx = t[0].clientX - t[1].clientX;
        let dy = t[0].clientY - t[1].clientY;
        let distance = Math.sqrt(dx * dx + dy * dy);
        if (!sprite._pinch) {
            sprite._pinch = {
                p: {
                    distance: distance,
                    date: new Date()
                }
            };
            sprite.emit('pinchstart');
            return
        }
        let now = new Date();
        let interval = now - sprite._pinch.p.date;
        if (interval < 12) {
            return
        }
        let center = {
            x: (t[0].clientX + t[1].clientX) / 2,
            y: (t[0].clientY + t[1].clientY) / 2
        };
        let event = {
            scale: distance / sprite._pinch.p.distance,
            velocity: distance / interval,
            center: center,
            data: e.data
        };
        sprite.emit('pinchmove', event);
        sprite._pinch.pp = {
            distance: sprite._pinch.p.distance,
            date: sprite._pinch.p.date
        };
        sprite._pinch.p = {
            distance: distance,
            date: now
        }
    }

    function end(e) {
        sprite.removeListener('touchmove', move);
        if (!sprite._pinch) {
            return
        }
        if (inertia && sprite._pinch.pp) {
            if (sprite._pinch.intervalId) {
                return
            }
            let interval = new Date() - sprite._pinch.p.date;
            let velocity = (sprite._pinch.p.distance - sprite._pinch.pp.distance) / interval;
            let center = sprite._pinch.p.center;
            let distance = sprite._pinch.p.distance;
            sprite._pinch.intervalId = setInterval(() => {
                if (Math.abs(velocity) < 0.04) {
                    clearInterval(sprite._pinch.intervalId);
                    sprite.emit('pinchend');
                    sprite._pinch = null;
                    return
                }
                let updatedDistance = distance + velocity * 12;
                let event = {
                    scale: updatedDistance / distance,
                    velocity: velocity,
                    center: center,
                    data: e.data
                };
                sprite.emit('pinchmove', event);
                distance = updatedDistance;
                velocity *= 0.8;
            }, 12)
        } else {
            sprite.emit('pinchend');
            sprite._pinch = null
        }
    }
};

//from https://stackoverflow.com/questions/7184573/pick-up-the-android-version-in-the-browser-by-javascript
Common.getAndroidVersion = function (ua) {
    ua = (ua || navigator.userAgent).toLowerCase();
    const match = ua.match(/android\s([0-9\.]*)/);
    return match ? match[1] : false;
};

/**
 * Custom tween
 * @param obj
 * @param time
 * @param params
 * @returns {TweenLite|TweenMax|TimelineLite|*}
 */
Common.erraticTween = function (obj, time, params = {delay: 0}) {
    params.ease = CustomEase.create("custom", "M0,0,C0,0,0.065,0.167,0.08,0.205,0.09,0.2,0.124,0.182,0.135,0.176,0.157,0.223,0.21,0.59,0.22,0.608,0.223,0.585,0.298,0.12,0.3,0.111,0.3,0.118,0.309,0.262,0.315,0.345,0.322,0.36,0.325,0.372,0.335,0.388,0.352,0.417,0.372,0.439,0.39,0.463,0.391,0.502,0.394,0.58,0.395,0.583,0.396,0.578,0.418,0.461,0.43,0.399,0.431,0.397,0.463,0.611,0.464,0.61,0.475,0.621,0.488,0.448,0.495,0.455,0.495,0.449,0.498,0.417,0.5,0.404,0.512,0.401,0.562,0.262,0.572,0.26,0.577,0.293,0.568,0.499,0.58,0.568,0.597,0.639,0.603,0.787,0.608,0.806,0.616,0.794,0.698,0.64,0.705,0.63,0.705,0.638,0.708,0.685,0.71,0.72,0.711,0.734,0.713,0.745,0.715,0.756,0.719,0.759,0.737,0.781,0.742,0.784,0.746,0.83,0.743,0.912,0.745,0.925,0.756,0.907,0.863,0.732,0.88,0.705,0.894,0.741,1,1,1,1");
    return TweenMax.to(obj, time, params);
};

/**
 * Dijkstra implementation of a path finder. Prefer this over A* if you have multiple agents with same starting position
 * and you are using a weighted graph. For non weighted graphics use BFS. For a single agent with a known single target destination use A*.
 * Or alternatively if you are unsure what your target is you can calc the path to all nodes, and then just retrieve the path to the target
 * node once you know it which could be useful depending on use case.
 *
 * @class
 */
class Dijkstra {
    constructor() {
        /**
         * @type {null}
         * @private
         */
        this._graph = null;

        /**
         * @type {null}
         * @private
         */
        this._source = null;

        //todo - add findPath() function which terminates when u === v
        /**
         * @type {null}
         * @private
         */
        this._target = null;//note we may want to target if we only have one agent, but A* is probably better for this case so prefer that if you don't need to guarantee the shortest path

        /**
         * Vertex set Q
         * @type {Array}
         * @private
         */
        this._verts = [];

        /**
         * @type {null}
         * @private
         */
        this._paths = null;
    }

    init() {

        if (!this._graph) throw new Error('must set graph before init');
        if (!this._source) throw new Error('must set source before init');

        //--create vertex set Q--//
        for (let x = 0; x < this._graph.length; x++) {
            for (let y = 0; y < this._graph[x].length; y++) {
                // All nodes initially in Q (unvisited nodes)
                const vert = this._graph[x][y];

                vert.distance = Number.POSITIVE_INFINITY;
                vert.prev = null;
                vert.neighbours = [];

                if (x > 0) vert.neighbours.push(this._graph[x - 1][y]);//grid sq left
                if (x < this._graph.length - 1) vert.neighbours.push(this._graph[x + 1][y]);//grid sq right
                if (y > 0)vert.neighbours.push(this._graph[x][y - 1]);//grid sq above
                if (y < this._graph[x].length - 1)vert.neighbours.push(this._graph[x][y + 1]);//grid sq below

                this._verts.push(vert);
            }
        }
        let s = this._source;
        this._verts[this._graph.length * s.x + s.y].distance = 0;//set source to source distance as zero (ensures this is first in our list becaue it has the lowest dist)
    }

    findPaths() {

        const descending = (a, b) => b.distance - a.distance;//descending sort function

        const paths = [];

        while (this._verts.length > 0) {

            //TODO can we take the sort out for optimisation?

            //--find node with least dist by sorting--//
            // this._verts = Common.sortDistances(this._verts, true);   //highToLow
            this._verts.sort(descending); //way outperforms my quick sort function (100 to 300 percent quicker)

            const u = this._verts[this._verts.length - 1];//take last element which is the one with the shortest distance

            this._verts.pop();//remove u from vert list (Q)

            //--for each neighbour v of u--//
            for (let i = 0; i < u.neighbours.length; i++) {
                const v = u.neighbours[i];
                const sourceToV = u.distance + Common.distance(u.x, u.y, v.x, v.y);
                if (sourceToV < v.distance) {
                    //we found a new shortest distance to this node v
                    v.distance = sourceToV;//store dist
                    v.prev = u;//store prev node

                    paths.push(v);
                }
            }
        }

        this._paths = paths;

        return paths;
    }

    /**
     * Fetches the path from the this._paths pre calculated paths to all nodes
     * @param pos
     */
    retrievePathTo(pos) {
        let node;
        for (let i = 0; i < this._paths.length; i++) {
            if (Common.compareXY(pos, this._paths[i])) {
                node = this._paths[i];
            }
        }

        if (!node) {
            throw new Error("can't retrieve path, position not on graph");
        }

        const path = [];

        //--trace back to start node to create the path--//
        var recurse = ()=> {   //using a little recursive function to trace the path backwards
            path.push({x: node.x, y: node.y});
            if (node.prev) {
                node = node.prev;
                recurse();
            }
        };
        recurse();

        return path;
    }

    reset() {
        this.init();
    }

    test(scene) {

        const tWid = 50;
        const holder = new PIXI.Container();
        const gridSize = 15;
        const graph = Common.matrix(gridSize, gridSize);
        holder.x = Common.STAGE_WIDTH * 0.5 - tWid * (gridSize * 0.5);
        scene.addChild(holder);

        for (let x = 0; x < gridSize; x++) {
            for (let y = 0; y < gridSize; y++) {

                let sp = P3.createSprite(PIXI.Texture.WHITE, holder);
                sp.x = x * tWid;
                sp.y = y * tWid;

                sp.width = tWid - 2;
                sp.height = tWid - 2;

                sp.tint = 0xD8D8D8;

                graph[x][y] = {x: x, y: y};//grid should be stored as int and we will multiply out to get tile pos
            }
        }

        this.graph = graph;
        this.source = graph[0][0]; //set source to be top left

        let t0 = performance.now();
        this.init();
        const paths = this.findPaths();
        let t1 = performance.now();
        console.warn("found paths in : " + (t1 - t0));

        const path = this.retrievePathTo({x: gridSize - 1, y: gridSize - 1}); //retrieve path to bottom right

        console.log(paths);
        console.log(path);

        let sp = P3.createSprite(PIXI.Texture.WHITE, holder);
        sp.anchor.set(0.5);
        sp.position.set(graph[0][0].x, graph[0][0].y);
        sp.width = tWid * 0.5;
        sp.height = tWid * 0.5;

        followPath(sp, tWid, path);

        function followPath(sprite, tWid, path) {
            let node = path[path.length - 1];
            TweenMax.to(sprite, 0.5, {
                x: node.x * tWid,
                y: node.y * tWid + tWid * 0.5,
                ease: Power0.easeNone,
                onComplete: ()=> {
                    path.pop();
                    if (path.length > 0) followPath(sprite, tWid, path);
                }
            })
        }
    }

    set graph(value) {
        this._graph = value;
    }

    set source(value) {
        this._source = value;
    }

    set target(value) {
        this._target = value;
    }
}
Common.PathD = new Dijkstra();

/**
 * Best performing path finding algorithm in cases where node distances are all the same (unweighted graph / grid).
 * Could be adapted to use without a target in which case it will find path to every node,
 * a possible use for this could be enemies in an RTS game.
 * @class
 */
class BreadthFirst {
    constructor() {
        /**
         * @type {null}
         * @private
         */
        this._graph = null;

        /**
         * @type {null}
         * @private
         */
        this._source = null;

        /**
         * @type {null}
         * @private
         */
        this._target = null;

        /**
         * List of nodes currently being explored
         * @type {Array}
         * @private
         */
        this._openList = [];
    }

    init() {

        if (!this._graph) throw new Error('must set graph before init');
        if (!this._source) throw new Error('must set source before init');

        let startNode;

        for (let x = 0; x < this._graph.length; x++) {
            for (let y = 0; y < this._graph[x].length; y++) {
                let vert = this._graph[x][y];

                vert.neighbours = [];
                vert.prev = null;

                if (x > 0) vert.neighbours.push(this._graph[x - 1][y]);//grid sq left
                if (x < this._graph.length - 1) vert.neighbours.push(this._graph[x + 1][y]);//grid sq right
                if (y > 0)vert.neighbours.push(this._graph[x][y - 1]);//grid sq above
                if (y < this._graph[x].length - 1)vert.neighbours.push(this._graph[x][y + 1]);//grid sq below

                if (Common.compareXY({x: x, y: y}, this._source)) {//if node is source node we can immediately mark as visited
                    vert.visited = true;
                    startNode = vert;
                }
            }
        }

        //--we want the list to be fifo--//
        this._openList.reverse();
        this._openList.push(startNode);

    }

    find() {

        /*
         -PSUEDOCODE-
         unmark all vertices
         choose some starting vertex x
         mark x
         list L = x
         tree T = x
         while L nonempty
         choose some vertex u from front of list
         visit u
         for each unmarked neighbor v
         mark v
         add it to end of list
         add edge uv to T
         */

        if (!this._target) throw new Error('must set target before performing BFS');

        let endNode;

        let arr = [];
        while (this._openList.length > 0) {
            const u = this._openList[this._openList.length - 1];//get our first vertex
            this._openList.pop();
            u.visited = true;//mark as visited

            if (Common.compareXY(u, this._target)) {
                console.warn("found target");
                endNode = u;
                break;
            }

            for (let i = 0; i < u.neighbours.length; i++) {
                const v = u.neighbours[i];
                if (!v.visited) {
                    v.visited = true;
                    v.prev = u;

                    this._openList.unshift(v);//fifo

                    const edge = {start: u, end: v};
                    arr.push(edge);
                }
            }
        }

        // console.log(this._closedList);

        // console.log(arr);

        let path = [];

        let node = endNode;
        //--trace back to start node to create the path--//
        var recurse = ()=> {   //using a little recursive function to trace the path backwards
            path.push({x: node.x, y: node.y});
            if (node.prev) {
                node = node.prev;
                recurse();
            }
        };
        recurse();


        return path;
    }

    test(scene) {

        const tWid = 25;
        const holder = new PIXI.Container();
        const gridSize = 25;
        const graph = Common.matrix(gridSize, gridSize);
        holder.x = Common.STAGE_WIDTH * 0.5 - tWid * (gridSize * 0.5);
        scene.addChild(holder);

        for (let x = 0; x < gridSize; x++) {
            for (let y = 0; y < gridSize; y++) {

                let sp = P3.createSprite(PIXI.Texture.WHITE, holder);
                sp.x = x * tWid;
                sp.y = y * tWid;

                sp.width = tWid - 2;
                sp.height = tWid - 2;

                sp.tint = 0xD8D8D8;

                graph[x][y] = {x: x, y: y};//grid should be stored as int and we will multiply out to get tile pos
            }
        }

        this.graph = graph;
        this.source = graph[0][0]; //set source to be top left
        this.target = {x: gridSize - 1, y: gridSize - 1};

        let t0 = performance.now();
        this.init();
        const path = this.find();
        let t1 = performance.now();
        console.warn("found paths in : " + (t1 - t0));

        // const path = Common.Path.retrievePathTo({x: gridSize - 1, y: gridSize - 1}); //retrieve path to bottom right

        // return;
        //  console.log(paths);
        console.log(path);

        let sp = P3.createSprite(PIXI.Texture.WHITE, holder);
        sp.anchor.set(0.5);
        sp.position.set(graph[0][0].x, graph[0][0].y);
        sp.width = tWid * 0.5;
        sp.height = tWid * 0.5;

        followPath(sp, tWid, path);

        function followPath(sprite, tWid, path) {
            let node = path[path.length - 1];
            TweenMax.to(sprite, 0.5, {
                x: node.x * tWid,
                y: node.y * tWid + tWid * 0.5,
                ease: Power0.easeNone,
                onComplete: ()=> {
                    path.pop();
                    if (path.length > 0) followPath(sprite, tWid, path);
                }
            })
        }
    }

    set graph(value) {
        this._graph = value;
    }

    set source(value) {
        this._source = value;
    }

    set target(value) {
        this._target = value;
    }
}
Common.PathBFS = new BreadthFirst();

//===================================================
//
// Jon's Methods
//
//===================================================

/**
 * @type {boolean}
 * @static
 */
Common.randBool = function () {
    return Math.random() > 0.5;
};

/**
 * @type {boolean}
 * @static
 */
Common.toOneDecimalStr = function (a) {
    var result = a.toFixed(1);
    if (result[result.indexOf(".") + 1] == "0")
        result = result.substr(0, result.indexOf("."));

    return result;
};

/**
 * @type {number}
 * @static
 */
Common.randomInt = function (min, max) {
    return Math.floor(Math.random() * ( max - min + 1 ) + min);
};

/**
 * @type {Array<object>}
 * @static
 */
Common.heapPermutations = function (arrElement) {
    var arr = arrElement.slice();
    var permutations = [];

    function swap(a, b) {
        var tmp = arr[a];
        arr[a] = arr[b];
        arr[b] = tmp;
    }

    function generate(n) {
        if (n == 1)
            permutations.push(arr.slice());
        else {
            for (var i = 0; i != n; ++i) {
                generate(n - 1);
                swap(n % 2 ? 0 : i, n - 1);
            }
        }
    }

    generate(arr.length);

    return permutations;
};

/**
 * @returns Number
 */
Common.getScreenPositionLeft = function () {
    return Math.max(0, Common.STAGE_WIDTH * 0.5 - P3.View.width * 0.5);
};

/**
 * @returns Number
 */
Common.getScreenPositionRight = function () {
    return Math.min(Common.STAGE_WIDTH, Common.STAGE_WIDTH * 0.5 + P3.View.width * 0.5);
};

Common.distanceBetween = function (point1, point2) {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
};

Common.angleBetween = function (point1, point2) {
    return Math.atan2(point2.x - point1.x, point2.y - point1.y);
};

Common.randomFloat = function (min, max) {
    return Math.random() * ( max - min ) + min;
};

Common.midPointBtw = function (p1, p2) {
    return {
        x: p1.x + ( p2.x - p1.x ) / 2,
        y: p1.y + ( p2.y - p1.y ) / 2
    };
};

Common.hexToRgb = function (hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
};

/**
 * @type {number}
 * @static
 */
Common.findPositionInScene = function (sprite, scene) {
    var result = new PIXI.Point(sprite.x, sprite.y);

    var parent = sprite.parent;
    while (parent != scene) {
        result.x += parent.x;
        result.y += parent.y;

        parent = parent.parent;
    }

    return result;
};

window.Common = Common;